import { Button } from "components/DesignSystem/Button/Button";
import HeaderFilter from "components/DesignSystem/HeaderFilter/HeaderFilter";
import { DateFilter } from "components/Filters/DateFilter";
import { Funnel } from "components/icons/Funnel";
import { Form, Formik, FormikValues } from "formik";
import { AnimatePresence } from "framer-motion";
import { useQuery, useUpdateQuery } from "hooks/useQuery";
import { useState } from "react";

export type UpdateFilterType = (name: string, value: string[] | null) => void;

type DateSelectHeaderProps = {
  startDateKey: string;
  endDateKey: string;
  selectPeriodKey: string;
  title: string;
};

export const DateSelectHeader = ({
  startDateKey,
  endDateKey,
  selectPeriodKey,
  title,
}: DateSelectHeaderProps) => {
  const [isOpen, setOpen] = useState(false);
  const { updateMultiple } = useUpdateQuery();
  const query = useQuery();
  const selectedStartDate = query.get(startDateKey) || "";
  const selectedEndDate = query.get(endDateKey) || "";
  const selectedPeriod = query.get(selectPeriodKey) || "";

  const applyFilter = (values: FormikValues) => {
    const { START_DATE, END_DATE, SELECT_PERIOD } = values;
    updateMultiple([
      { query: startDateKey, value: START_DATE || null },
      { query: endDateKey, value: END_DATE || null },
      { query: selectPeriodKey, value: SELECT_PERIOD || null },
    ]);
    setOpen(false);
  };

  const handleClearFilter = () => {
    updateMultiple([
      { query: startDateKey, value: null },
      { query: endDateKey, value: null },
      { query: selectPeriodKey, value: null },
    ]);
  };

  const isActive =
    Boolean(selectedStartDate) ||
    Boolean(selectedEndDate) ||
    Boolean(selectedPeriod);

  return (
    <div className="t-flex t-items-center t-justify-between t-w-full">
      <div>{title}</div>
      <HeaderFilter.Root open={isOpen} setOpen={setOpen}>
        <HeaderFilter.Trigger
          icon={<Funnel />}
          isActive={isActive}
          selectedCount={1}
          onClear={handleClearFilter}
          setOpen={setOpen}
        />
        <AnimatePresence>
          <HeaderFilter.Portal {...HeaderFilter.Portal}>
            <Formik
              initialValues={{
                START_DATE: selectedStartDate,
                END_DATE: selectedEndDate,
                SELECT_PERIOD: selectedPeriod,
              }}
              onSubmit={applyFilter}
            >
              {({ setFieldValue, values }) => (
                <Form>
                  <HeaderFilter.Content className="t-w-64">
                    <HeaderFilter.Body>
                      <DateFilter
                        updateFilter={(name, newValue) =>
                          setFieldValue(name, newValue)
                        }
                        values={values}
                        addMenuPortal
                      />
                    </HeaderFilter.Body>
                    <HeaderFilter.Footer>
                      <Button
                        size="small"
                        type="button"
                        onClick={() => setOpen(false)}
                      >
                        Clear
                      </Button>
                      <Button customType="primary" size="small" type="submit">
                        Apply
                      </Button>
                    </HeaderFilter.Footer>
                  </HeaderFilter.Content>
                </Form>
              )}
            </Formik>
          </HeaderFilter.Portal>
        </AnimatePresence>
      </HeaderFilter.Root>
    </div>
  );
};
